import {AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import {FormControl} from '@angular/forms';
import {SearchEventsService} from '../../../../components/search-container/search.service';
import {ActivatedRoute, Router} from '@angular/router';
import "rxjs-compat/add/operator/debounceTime";
import "rxjs-compat/add/operator/distinctUntilChanged";

@Component({
    selector: 'app-searchbar',
    templateUrl: './searchbar.component.html',
    styleUrls: ['./searchbar.component.css']
})
export class SearchbarComponent implements OnInit , AfterViewInit, OnDestroy {
    searchField: FormControl = new FormControl();
    keyword;

    constructor(private searchService: SearchEventsService , private router: Router , private route: ActivatedRoute) {

    }

    ngOnDestroy(): void {
       this.keyword = null;
    }

    ngOnInit(): void {

        this.searchField.valueChanges
            .debounceTime(2000)
            .distinctUntilChanged()
            .subscribe(value => {
                // this.searchField.setValue(value);

                // this.searchService.EmitSearchTriggeredEvent(value);
                if (value != '') {
                    localStorage.setItem('searchKeyword' , value);
                    this.router.navigate(['/search/' + value]);
                }


            });

    }
    ngAfterViewInit(): void {
        // if (this.route.snapshot.paramMap.get('value') != undefined){
        //     this.keyword = this.route.snapshot.paramMap.get('value');
        // }
        let searchVal = localStorage.getItem('searchKeyword');

        // console.log(decodeURIComponent(this.router.url));

        if (searchVal != null && decodeURIComponent(this.router.url) === '/search/'+searchVal) {
            // console.log('inside the hh')
            // console.log(searchVal);
            this.keyword = searchVal;
        }else{
            // console.log('inside the hoho')
            // console.log(searchVal);

            localStorage.removeItem('searchKeyword');
        }
    }

}
